/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

/**
 * Shared entrance-animation timing (framer-motion, seconds).
 *
 * These drive the staggered "cascade" reveal used by heroes and sections via the
 * `Animate` atom. The values are tuned so elements settle quickly (perceived-load
 * speed) while preserving the synced, sequential feel and `easeOut` easing.
 *
 * The single biggest lever is `duration.move`: the distance a `slide` element
 * travels. Keeping it well above `duration.opacity` is what makes the motion read
 * as "gliding in" rather than "snapping in".
 *
 * NOTE: the hero background-glow keyframe in HeroAlpha.MainStack.tsx is a Panda
 * `css()` literal (must be statically extractable at build time) and therefore
 * cannot read these constants at runtime — it is hand-kept in step with these
 * values (`fadein 1.2s ease-out 0.4s`).
 */
export const ANIMATION = {
	// Entrance transition durations.
	duration: {
		opacity: 0.2, // fade in — intentionally snappy
		move: 0.5, // x/y slide travel — the main perceived-speed lever
	},
	// Staggered entrance delays that create the top-to-bottom cascade.
	delay: {
		title: 0.03,
		description: 0.08,
		buttonBase: 0.15, // first button
		buttonStep: 0.06, // added per subsequent button
		heroBlurredImage: 0.15,
	},
} as const;
